export default function attachementExtractionFromTitle(title) {
    const matches = title.match(/\(?\d*[a-z]*\s*priedas\)?/gi); 
    return matches[matches.length - 1];
}